import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of, forkJoin } from 'rxjs';
import { Injectable } from '@angular/core';
import { tap, catchError } from 'rxjs/operators';
import { HttpService } from './http.service';
import { LegacyBookInitService } from './legacy-book-initializer.service';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  public tenantId: any;
  public propertyId: any;
  public serviceName: any;
  public functionName: any;
  public propertyName: any;

  observables: any = [];

  constructor(
    private _http: HttpClient,
    public httpService: HttpService,
    private configservice: LegacyBookInitService,
    private router: Router
  ) {
    this.serviceName = this.configservice.getcasioToken_server_name();
    this.tenantId = this.configservice.tenantId;
    this.propertyId = this.configservice.propertyId;
    this.functionName = this.configservice.casinoTokenDeleteFunction;
    this.propertyName = this.configservice.PropertyData.PropNameKeyList.validCasino;
  }

  deleteToken(details) {
    this.observables = [];
    let URL = [];
    for (let i = 0; i < details.length; i++) {
      URL[i] =
        this.configservice.getCloudDomainName() +
        '/' +
        this.serviceName +
        '/tenants/' +
        this.tenantId +
        ('/context/' + this.configservice.PropertyData.ContextId + '/') +
        'propertyName/' +
        this.propertyName +
        '/casinoNo/' +
        details[i].casinoNumber +
        '/token/' +
        details[i].token +
        '/' +
        this.functionName +
        '?appName=wbe';
      this.observables.push(
        this.httpService.delete(URL[i], this.configservice.serviceHeaders).pipe(
          tap((data) => console.log(data)),
          catchError(this.handleError('getOffers', []))
        )
      );
    }
    return forkJoin(this.observables);
  }
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }
}
